"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import styles from './Align.module.scss.mjs';
import clsx from 'clsx';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';

const Align = flowComponent("Align", (props) => {
  const { children, className } = props;
  const rootClassName = clsx(styles.align, className);
  const propsContext = {
    Text: { className: styles.text },
    Button: { className: styles.button },
    Avatar: { className: styles.avatar, size: "m" },
    CopyButton: { size: "s", className: styles.copyButton },
    Icon: { size: "s", className: styles.icon },
    ContextualHelpTrigger: {
      Button: {
        className: styles.contextualHelpTriggerButton
      }
    }
  };
  return /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children: /* @__PURE__ */ jsx("div", { className: rootClassName, children }) });
});

export { Align, Align as default };
//# sourceMappingURL=Align.mjs.map
